// when updating this file, keep in mind that the examples images for each
// group are ordered, and referenced by index elsewhere in the application (noteably, the quiz)
// thus if you are adding to an existing set willy-nilly, add to the end of the list

export default {
  fixation: {
    arthrodesis: {
      title: 'Arthrodesis',
      examples: [
        {
          url: 'wrist.jpg',
          caption: 'Four corner arthrodesis of the hamate, lunate, capitate, and triquetrum as well as scaphoidectomy.'
        },
        {
          url: 'hindfoot.jpg',
          caption: 'Triple arthrodesis of the subtalar, calcaneocuboid, and talonavicular joints.'
        },
        {
          url: 'tibiotalocalc.PNG',
          caption: 'Tibiotalocalcaneal arthrodesis.'
        },
        {
          url: 'tibiotalocalc2.PNG',
          caption: 'Tibiotalocalcaneal arthrodesis and distal fibular resection.'
        },
        {
          url: 'tibiotalocalc3.PNG',
          caption: 'Tibiotalocalcaneal arthrodesis and distal fibular resection.'
        },
        {
          url: 'wristarthrodesis.PNG',
          caption: 'Wrist arthrodesis.'
        }
      ]
    },
    bladeplate: {
      title: 'Blate Plate and Screw',
      examples: [
        {
          url: 'bladescrew.jpg',
          caption: 'Bilateral blade plate-screw fixation of subtrochanteric osteostomies or fractures.'
        }
      ]
    },
    cast: {
      title: 'Cast',
      examples: [
        {
          url: 'cast.jpg',
          caption: 'Cast material shown as well as percutaneous pinning of a complex elbow fracture'
        }
      ]
    },
    cerclage: {
      title: 'Cerclage Wires',
      examples: [
        {
          url: 'cerclage.jpg',
          caption: 'Left total hip arthroplasty with plate-screw fixation of the proximal femur with cerclage wire reinforcement.'
        }
      ]
    },
    cerclage_bands: {
      title: 'Cerclage Bands',
      examples: [
        {
          url: 'cerclageband.PNG',
          caption: 'Left total hip arthroplasty with cerclage band reinforcement at the proximal femur.'
        },
        {
          url: 'cerclageband2.PNG',
          caption: 'Right hip arthroplasty long femoral stem with cerclage bands (3) for reinforcement.'
        }
      ]
    },
    dynamic: {
      title: 'Dynamic Compression Screw',
      examples: [
        {
          url: 'dynamiccompression.jpg',
          caption: 'Dynamic compression screw through an intertrochanteric fracture of the left femur.'
        }
      ]
    },
    exfix: {
      title: 'External Fixation',
      examples: [
        {
          url: 'exfix.jpg',
          caption: 'External fixation is a temporary strategy before internal fixation.'
        }
      ]
    },
    hagie: {
      title: 'Hagie Pin',
      examples: [
        {
          url: 'hagiepin.jpg',
          caption: 'Hagie pin through a clavicular fracture.'
        }
      ]
    },
    imnail: {
      title: 'Intramedullary Nail',
      examples: [
        {
          url: 'imnail.jpg',
          caption: 'Intramedullary nail with interlocking screws in the femur, with periosteal reaction and loosening at the proximal screw.'
        },
        {
          url: 'imnail2.jpg',
          caption: 'Intramedullary nail with interlocking screws for a complex tibia and fibula fracture.'
        }
      ]
    },
    percutaneous_pin: {
      title: 'Percutaneous Pin',
      examples: [
        {
          url: 'percpin.jpg',
          caption: 'Percutaneous pinning of a complex elbow fracture.'
        },
        {
          url: 'percpin2.png',
          caption: 'Percutaneous pinning following osteotomy for hammertoe correction.'
        }
      ]
    },
    platescrew: {
      title: 'Plate and Screw',
      examples: [
        {
          url: 'platescrew.jpg',
          caption: 'Total knee arthroplasty with plate-screw fixation of the proximal tibia.'
        }
      ]
    },
    screws: {
      title: 'Screws and Pins',
      examples: [
        {
          url: 'screw.jpg',
          caption: 'Screw through the fifth metatarsal for a Jones fracture.'
        },
        {
          url: 'screw2.jpg',
          caption: 'Screw fixation of a medial malleolar fracture as well as screws and pins fixing a talar fracture.'
        }
      ]
    },
    spiral: {
      title: 'Spiral Blade',
      examples: [
        {
          url: 'spiralblade.jpg',
          caption: 'Spiral blade with intramedullary nail fixation of a intertrochanteric femur fracture. This provides dynamic compression.'
        }
      ]
    },
    splint: {
      title: 'Splint',
      examples: [
        {
          url: 'splint.jpg',
          caption: 'Splint material shown. Used for initial stabilization, is adjustable, and allows for swelling.'
        }
      ]
    },
    syndesmotic: {
      title: 'Syndesmotic Screw',
      examples: [
        {
          url: 'syndesmoticscrew.png',
          caption: 'Plate-screw fixation of the distal fibula with syndesmotic screw.'
        }
      ]
    },
    tension: {
      title: 'Tension Wires and K-Wires',
      examples: [
        {
          url: 'kwire.jpg',
          caption: 'Tension wire (thinner wire) and K-wire (thicker wire/pin) fixation of a displaced proximal ulna fracture. Plate-screw fixation of the proximal radius.'
        },
        {
          url: 'tensionwire.jpg',
          caption: 'Tension wire and K-wire fixation of a displaced patella fracture.'
        }
      ]
    }
  },
  ankle: {
    arthroplasty: {
      title: 'Ankle Arthroplasty',
      examples: [
        {
          url: 'totalankleap.jpg',
          caption: 'Frontal view of an ankle athroplasty.'
        },
        {
          url: 'totalanklelat.jpg',
          caption: 'Lateral view of an ankle athroplasty.'
        }
      ]
    }
  },
  elbow: {
    arthroplasty: {
      title: 'Elbow Arthroplasty',
      examples: [
        {
          url: 'totalelbow.PNG',
          caption: 'Total elbow arthroplasty with distal humeral replacement.'
        },
        {
          url: 'totalelbow2.PNG',
          caption: 'Total elbow arthroplasty.'
        },
        {
          url: 'totalelbow4.PNG',
          caption: 'Total elbow arthroplasty with distal humeral and proximal ulnar replacement.'
        }
      ]
    }
  },
  foot: {
    duvries: {
      title: 'DuVries Arthroplasty',
      description: `Proximal phalangeal head resection and fixation of the proximal interphalangeal joint.`,
      examples: [
        {
          url: 'duvries.PNG',
          caption: 'DuVries Arthroplasty of the 2nd 3rd and 5th toes.'
        },
        {
          url: 'duvries2.PNG',
          caption: 'DuVries Arthroplasty of the 2-4 toes.'
        },
        {
          url: 'duvries3.PNG',
          caption: 'DuVries Arthroplasty of the 2-5 toes.'
        }
      ]
    },
    lapiplasty: {
      title: 'Lapiplasty',
      description: `
        Lapiplasty or Lapidus bunionectomy involves an osteotomy at the base of
        the first metatarsal and realignment and fixation of the first tarsometatarsal joint.
      `,
      examples: [
        {
          url: 'lapiplasty.PNG',
          caption: 'AP view of lapiplasty fixation hardware.'
        },
        {
          url: 'lapiplasty2.PNG',
          caption: 'Lateral view of lapiplasty fixation hardware.'
        },
        {
          url: 'lapiplasty3.PNG',
          caption: 'AP view of lapiplasty fixation hardware.'
        }
      ]
    }
  },
  hip: {
    spacer: {
      title: 'Articulating Antibiotic Spacer',
      examples: [
        {
          url: 'spacer.jpg',
          caption: 'An articulating antibiotic spacer with prominent acetabular and femoral cement as well as heterotopic bone formation.'
        }
      ]
    },
    unipolar: {
      title: 'Unipolar Hip Hemi-arthroplasty',
      examples: [
        {
          url: 'unipolarhip.png',
          caption: 'Unipolar hip hemi-arthroplasty is shown. Note the preserved native acetabulum.'
        },
        {
          url: 'unipolarhip2.png',
          caption: 'Unipolar hip hemi-arthroplasty is shown. Note the preserved native acetabulum.'
        }
      ]
    },
    bipolar: {
      title: 'Bipolar Hip Hemi-arthroplasty',
      examples: [
        {
          url: 'bipolarhip.jpg',
          caption: 'A bipolar hip hemi-arthroplasty. The native acetabulum is preserved.'
        },
        {
          url: 'bipolarhip4.png',
          caption: 'A bipolar hip hemi-arthroplasty. The native acetabulum is preserved.'
        }
      ]
    },
    total: {
      title: 'Total Hip Arthroplasty',
      examples: [
        {
          url: 'totalhip.jpg',
          caption: 'Noncemented right total hip arthroplasty. Note the acetabular component with screw.'
        },
        {
          url: 'djdhip2.png',
          caption: 'Noncemented left total hip arthroplasty. Note the acetabular component.'
        }
      ]
    },
    cemented: {
      title: 'Cemented Total Hip Arthroplasty',
      examples: [
        {
          url: '',
          caption: ''
        }
      ]
    }
  },
  knee: {
    acl: {
      title: 'ACL Repair',
      examples: [
        {
          url: 'acl3.png',
          caption: 'Frontal view of anterior cruciate ligament repair.'
        },
        {
          url: 'acl4.png',
          caption: 'Lateral view of anterior cruciate ligament repair.'
        }
      ]
    },
    femoral: {
      title: 'Distal Femoral Replacement',
      examples: [
        {
          url: 'distalfemoral.PNG',
          caption: 'Lateral view of distal femoral and proximal tibial replacement with cerclage wire support.'
        }
      ]
    },
    unicompartmental: {
      title: 'Unicompartmental Knee Arthroplasty',
      examples: [
        {
          url: 'unicompartmentalknee.jpg',
          caption: 'Frontal view of medial compartment unicompartmental knee arthroplasty.'
        },
        {
          url: 'unicompartmentalknee2.jpg',
          caption: 'Lateral view of medial compartment unicompartmental knee arthroplasty.'
        }
      ]
    },
    nostemtotal: {
      title: 'Total Knee Arthroplasty',
      examples: [
        {
          url: 'totalkneenostem.jpg',
          caption: 'Frontal view of a total knee arthroplasty.'
        },
        {
          url: 'totalkneenostemlat.jpg',
          caption: 'Lateral view of a total knee arthroplasty.'
        },
        {
          url: 'totalkneeshort.jpg',
          caption: 'Short stem total knee arthroplasty.'
        }
      ]
    },
    static: {
      title: 'Static Antibiotic Spacer',
      examples: [
        {
          url: 'staticknee.PNG',
          caption: 'Lateral view of a static antibiotic spacer and cement.'
        }
      ]
    },
    pclsparing: {
      title: 'PCL Sparing Total Knee Arthroplasty',
      description: 'The thin metallic femoral component seen on the lateral view is the key to identification.',
      examples: [
        {
          url: 'pclsparing0.PNG',
          caption: 'Frontal view of a nonconstrained PCL sparing total knee arthroplasty.'
        },
        {
          url: 'pclsparing_lat0.PNG',
          caption: 'Lateral view of a nonconstrained PCL sparing total knee arthroplasty with patellar resurfacing.'
        }
      ]
    },
    constrained: {
      title: 'Constrained Total Knee Arthroplasty',
      examples: [
        {
          url: 'constrained_ap.PNG',
          caption: 'Frontal view of a constrained total knee arthroplasty with long femoral and tibial stems.'
        },
        {
          url: 'constrained_lat.PNG',
          caption: 'Lateral view of a constrained total knee arthroplasty with long femoral and tibial stems.'
        }
      ]
    },
    semiconstrained: {
      title: 'Semiconstrained Total Knee Arthroplasty',
      description: 'The thick metallic femoral component seen on the lateral view is the key to identification.',
      examples: [
        {
          url: 'semiconstrained_ap.PNG',
          caption: 'Frontal view of a semiconstrained total knee arthroplasty.'
        },
        {
          url: 'semiconstrained_lat.PNG',
          caption: 'Lateral view of a semiconstrained total knee arthroplasty.'
        }
      ]
    }
  },
  shoulder: {
    resurfacing: {
      title: 'Resurfacing Hemi-arthroplasty',
      examples: [
        {
          url: 'shoulderhemi.jpg',
          caption: 'Shoulder resurfacing hemi-arthroplasty is shown. The glenoid is not replaced.'
        }
      ]
    },
    total: {
      title: 'Total Shoulder Arthroplasty',
      examples: [
        {
          url: 'totalshoulder.jpg',
          caption: 'Conventional total shoulder arhtroplasty. A metallic marker at the glenoid indicates replacement.'
        },
        {
          url: 'totalshoulder2.jpg',
          caption: 'Axillary view of total shoulder arthroplasty.'
        }
      ]
    },
    reverse: {
      title: 'Reverse Total Shoulder Arthroplasty',
      examples: [
        {
          url: 'shoulderreverse.jpg',
          caption: 'A reverse total shoulder arthroplasty uses the deltoid for action and is thus good if there is rotator cuff injury.'
        }
      ]
    }
  },
  spine: {
    acdf: {
      title: 'Anterior Cervical Discectomy and Fusion',
      examples: [
        {
          url: 'acdf.PNG',
          caption: 'Lateral view of C4-C7 anterior fusion with interbody cages.'
        },
        {
          url: 'acdf2.PNG',
          caption: 'Frontal view of C4-C7 anterior fusion with interbody cages.'
        },
        {
          url: 'acdf3.PNG',
          caption: 'Anterior cervical discectomy and fusion at C4-C6.'
        }
      ]
    },
    bonegraft: {
      title: 'Bone Graft',
      examples: [
        {
          url: 'bonegraft.PNG',
          caption: 'Frontal view of posterior and anterior spinal fusion with posterolateral bone graft (arrowheads), instrumentation, interbody cages, and laminectomy.'
        },
        {
          url: 'interbodybone.PNG',
          caption: 'L5-S1 posterior spinal fusion with instrumentation and interbody bone graft (arrow)'
        }
      ]
    },
    discarthroplasty: {
      title: 'Disc Arthroplasty',
      examples: [
        {
          url: 'discarthroplasty.PNG',
          caption: 'C5-C6 disc arthroplasty'
        },
        {
          url: 'discarthroplasty2.PNG',
          caption: 'C5-C6 disc arthroplasty'
        }
      ]
    },
    interbodycage: {
      title: 'Interbody Cage',
      examples: [
        {
          url: 'interbodycage.PNG',
          caption: 'L3-S1 posterior spinal fusion with instrumentation and L4-L5 interbody cage (radiodense marker annotated with arrow)'
        }
      ]
    },
    laminoplasty: {
      title: 'Laminoplasty',
      examples: [
        {
          url: 'laminoplasty.PNG',
          caption: 'Frontal view of C3-C7 left laminoplasty.'
        },
        {
          url: 'laminoplasty2.PNG',
          caption: 'Lateral view of C3-C7 laminoplasty.'
        }
      ]
    },
    postfusion: {
      title: 'Posterior Spinal Fusion with Instrumentation',
      examples: [
        {
          url: 'postfusion.PNG',
          caption: 'Lateral view of T11-L3 posterior spinal fusion with instrumentation for an L1 vertebral body compression fracture.'
        },
        {
          url: 'postfusion2.PNG',
          caption: 'Frontal view of T11-L3 posterior spinal fusion with instrumentation for an L1 vertebral body compression fracture.'
        }
      ]
    }
  },
  failure: {
    acl: {
      // TODO: tunnel to wide: aclfail3.png, aclfail4.png
    },
    arthrofibrosis: {
      title: 'Arthrofibrosis',
      examples: [
        {
          url: 'aclmri1.jpg',
          caption: 'T1 image of arhtrofibrosis, a fibrotic mass at the tibial insertion of the reconstruction which can limit mobility.'
        },
        {
          url: 'aclmri2.jpg',
          caption: 'T2 image of arhtrofibrosis, a fibrotic mass at the tibial insertion of the reconstruction which can limit mobility.'
        }
      ]
    },
    dislocation: {
      title: 'Dislocation',
      examples: [
        {
          url: 'shoulderdislocation.jpg',
          caption: 'Dislocated right reverse total shoulder arthroplasty.'
        },
        {
          url: 'hipdislocation.jpg',
          caption: 'Dislocated right total hip arthroplasty.'
        },
        {
          url: 'hipdislocation2.jpg',
          caption: 'Dislocated total hip arthroplasty.'
        },
        {
          url: 'hipdislocation3.jpg',
          caption: 'Dislocated right total hip arthroplasty.'
        }
      ]
    },
    hardwarefx: {
      title: 'Hardware Fracture',
      examples: [
        {
          url: 'anklefx.jpg',
          caption: 'Frontal view of fractured tibial plate.'
        },
        {
          url: 'anklefx2.jpg',
          caption: 'Lateral view of fractured tibial plate.'
        },
        {
          url: 'spinefx.jpg',
          caption: 'Multiple fractured pedicle screws.'
        },
        {
          url: 'spinefx2.jpg',
          caption: 'Multiple fractured pedicle screws.'
        },
        {
          url: 'femurfx.jpg',
          caption: 'Fractured screws within the femoral diaphysis.'
        },
        {
          url: 'femurfx2.jpg',
          caption: 'Fracture of the neck of the femoral component of a right total hip arthroplasty.'
        }
      ]
    },
    heterotopic: {
      title: 'Heterotopic Bone',
      examples: [
        {
          url: 'heterotopic.jpg',
          caption: 'Heterotopic bone formation medial and lateral to the proximal femur in patient with articulating antibiotic spacer.'
        },
        {
          url: 'heterotopic2.jpg',
          caption: 'Heterotopic bone formation lateral to the hip.'
        }
      ]
    },
    loosening: {
      title: 'Osteolysis/Loosening',
      examples: [
        {
          url: 'wristplatescrew.jpg',
          caption: 'Loosening of the third distal screw.'
        },
        {
          url: 'alignment2.jpg',
          caption: 'Loosening of all of the proximal screws and incomplete healing.'
        },
        {
          url: 'alignmentspine.jpg',
          caption: 'Loosening of one of the T12 pedicle screws (the screw with more prominent threads).'
        },
        {
          url: 'hiploosening.jpg', // 3
          caption: 'Lateral uncovering of the prosthetic femoral head due to acetabular component loosening.'
        },
        {
          url: 'shoulderloosening.jpg',
          caption: 'Loosening along the humeral stem.'
        },
        {
          url: 'shoulderloosening2.jpg',
          caption: 'Loosening along the humeral stem with anterior dislocation.'
        },
        {
          url: 'spinefail2.jpg', // before image is spinefail.jpg
          caption: 'Loosening of the interbody cage.'
        },
        {
          url: 'radiusloosening2.png', // before image is radiusloosening.png; 7
          caption: 'Loosening of the radial head prosthesis.'
        },
        {
          url: 'kneeloosening3.jpg',
          caption: 'Loosening of the tibial plate.'
        },
        {
          url: 'hipfail.jpg', // 9
          caption: 'Subsidence of the femoral component due to loosening.'
        },
        {
          url: 'hipfail3.jpg', // before image is hipfail2.jpg
          caption: 'Loosening of the acetabular component.'
        },
        {
          url: 'aclfail.png',
          caption: 'ACL tendon anchor within the femoral tunnel.'
        },
        {
          url: 'aclfail2.png',
          caption: 'ACL tendon anchor within the femoral tunnel.'
        }
      ]
    },
    particle: {
      title: 'Particle Disease',
      examples: [
        {
          url: 'particledz.jpg',
          caption: 'Extensive loosening along the femoral stem and acetabular component.'
        },
        {
          url: 'metallosis.jpg',
          caption: 'T1-weighted MRI showing pseudotumor (black, round area superior to left hip) due to susceptibility artifact from small metalic fragments.'
        },
        {
          url: 'metallosis2.jpg',
          caption: 'Metallosis with extensive metallic debris in the joint space and soft tissue around a total hip arthroplasty.'
        }
      ]
    },
    periprostheticfx: {
      title: 'Periprosthetic Fracture',
      examples: [
        {
          url: 'kneefx.jpg',
          caption: 'Periprosthetic adjacent to the tibial plate, status post plate-screw fixation.'
        },
        {
          url: 'kneefx2.jpg',
          caption: 'Acute periprosthetic fracture of the distal femur.'
        },
        {
          url: 'kneefx2lat.jpg',
          caption: 'Acute periprosthetic fracture of the distal femur.'
        },
        {
          url: 'hipfx.jpg',
          caption: 'Remote periproshetic fracture at the distal femoral stem component.'
        },
        {
          url: 'hipfx2.jpg',
          caption: 'Remote periproshetic fracture at the distal femoral stem component.'
        }
      ]
    },
    wear: {
      title: 'Polyethylene Wear',
      examples: [
        {
          url: 'wear_pre.JPG',
          caption: 'Normal appearance of total hip arthroplasty with the prosthetic femoral head component centered in the acetabular cup.'
        },
        {
          url: 'wear_post.JPG',
          caption: 'Eccentric position of the prosthetic femoral head within the acetabular cup due to polyethylene wear.'
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/ImageMeta.js